import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-progress-style-three',
  templateUrl: './progress-style-three.component.html',
  styleUrls: ['./progress-style-three.component.scss']
})
export class ProgressStyleThreeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
